import { Adjustments, CalendarV3, CloseSchedule } from "@repo/icons";
import { useSearch } from "@tanstack/react-router";
import {
  FullScreenModal,
  FullScreenModalDescription,
  FullScreenModalHeader,
  FullScreenModalTitle,
} from "@/components/full-screen-modal.tsx";
import {
  FullScreenListOption,
  FullScreenListOptionList,
  FullScreenListOptionTitle,
} from "@/components/full-screen-modal-list-option.tsx";

interface FullScreenModalScheduleProps {
  isOpen: boolean;
  onClose: () => void;
}

export const FullScreenModalSchedule = ({
  isOpen,
  onClose,
}: FullScreenModalScheduleProps): JSX.Element => {
  const searchParams: object = useSearch({
    strict: false,
  });

  const menuOptions = [
    {
      title: "Novo agendamento",
      icon: CalendarV3,
      route: "/appointment/create",
      search: searchParams
    },
    {
      title: "Configurar agendas",
      icon: Adjustments,
      route: "/settings/schedule-options/schedules",
    },
    {
      title: "Fechar agenda",
      icon: CloseSchedule,
      route: "/calendar/unavailable-slots/create",
      search: searchParams
    },
  ];

  return (
    <FullScreenModal isOpen={isOpen} onClose={onClose}>
      <FullScreenModalHeader>
        <FullScreenModalTitle>Como deseja personalizar sua agenda?</FullScreenModalTitle>
        <FullScreenModalDescription>
          Organize sua agenda como preferir
        </FullScreenModalDescription>
      </FullScreenModalHeader>

      <FullScreenListOptionList>
        {menuOptions.map((option, index) => (
          <FullScreenListOption key={option.title} index={index} {...option}>
            <option.icon size={24} className="fill-primary-500" />
            <FullScreenListOptionTitle>{option.title}</FullScreenListOptionTitle>
          </FullScreenListOption>
        ))}
      </FullScreenListOptionList>
    </FullScreenModal>
  );
};
